import { useMutation, useQueryClient } from '@tanstack/react-query';

import { tasksApi } from '../api';

interface UseDeleteTodoProjectParams {
  userId: string;
  boardId: string;
}

export const useDeleteTodoProject = () => {
  const queryClient = useQueryClient();

  const deleteProjectMutation = useMutation({
    mutationFn: ({ userId, boardId }: UseDeleteTodoProjectParams) => {
      return tasksApi.deleteTodoProject(userId, boardId).then(({ data }) => data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['lifestack.todo.projects'] });
      queryClient.invalidateQueries({ queryKey: ['lifestack.todo.tasks'] });
      queryClient.invalidateQueries({ queryKey: ['lifestack.user'] });
    },
  });

  return {
    deleteTodoProject: deleteProjectMutation.mutateAsync,
    ...deleteProjectMutation,
  };
};
